import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { centsToUnits } from '../utils/money.util';

/** Marca de cada divisa. Las que no estén aquí se muestran con su código ISO. */
const CURRENCY_MARK: Readonly<Record<string, string>> = {
  EUR: '€',
  GBP: '£',
  CLP: 'CLP',
  USD: 'USD',
};

const DIGITS_INFO = '1.2-2';

/**
 * Formatea un importe en céntimos como el resto de la aplicación: el número con
 * dos decimales y la marca de la divisa detrás, separada por un espacio
 * (`12.00 €`, `9.90 £`, `8000.00 CLP`).
 *
 * Usa `formatNumber` con el `LOCALE_ID` de la aplicación, y no el idioma activo
 * de ngx-translate, para dar exactamente el mismo resultado que el
 * `| number : '1.2-2'` del desglose de precio. Si no coincidieran, la ficha de un
 * servicio mostraría el precio y sus gastos con separadores distintos, que es de
 * donde venía el `€12,00` junto a un `23.50 €`.
 *
 * Por eso es puro: el resultado ya no depende del idioma de la interfaz, así que
 * tampoco hace falta el memo que necesitaba la versión impura.
 */
@Pipe({ name: 'expenseAmount' })
export class ExpenseAmountPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

  transform(
    amountInCents: number | null | undefined,
    currencyCode = 'EUR',
    symbolOverride?: string | null
  ): string {
    const cents = Number.isFinite(amountInCents) ? Number(amountInCents) : 0;
    const mark =
      (symbolOverride ?? '').trim() || CURRENCY_MARK[currencyCode] || currencyCode;

    return `${formatNumber(centsToUnits(cents), this.locale, DIGITS_INFO)} ${mark}`;
  }
}
